import { Tabs } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { PecSwitch, PrivateRoute, TabLink } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'
import { Redirect, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import { CredenciaisIntegracaoBox } from './credenciais-integracao/CredenciaisIntegracaoBox'
import { SistemasExternosBox } from './sistemas-externos/SistemasExternosBox'

const TITLE = 'Configurações de integração'

export function IntegracaoConfiguracaoRootView() {
  const { PILOTO_SISTEMAS_EXTERNOS_ENABLED, PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()
  const match = useRouteMatch()
  const sistemasExternosPath = `${match.url}/sistemas-externos`
  const credenciaisIntegracaoPath = `${match.url}/credenciais`
  const defaultPath = PILOTO_SISTEMAS_EXTERNOS_ENABLED ? sistemasExternosPath : credenciaisIntegracaoPath

  return (
    <>
      <Breadcrumb title={TITLE} />
      <PageHeaderSection title={TITLE}>
        <Tabs>
          {PILOTO_SISTEMAS_EXTERNOS_ENABLED && <TabLink to={`${sistemasExternosPath}`}>Sistemas externos</TabLink>}
          {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
            <TabLink to={`${credenciaisIntegracaoPath}`}>Credenciais de integração</TabLink>
          )}
        </Tabs>
      </PageHeaderSection>

      <PageContent>
        <PecSwitch>
          {PILOTO_SISTEMAS_EXTERNOS_ENABLED && (
            <PrivateRoute
              exact
              path={sistemasExternosPath}
              component={SistemasExternosBox}
              permission={Permissions.administracaoGeralDaInstalacao}
            />
          )}
          {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
            <PrivateRoute
              exact
              path={credenciaisIntegracaoPath}
              component={CredenciaisIntegracaoBox}
              permission={Permissions.administracaoGeralDaInstalacao}
            />
          )}
          <Redirect exact from={`${match.url}`} to={defaultPath} />
        </PecSwitch>
      </PageContent>
    </>
  )
}
